export const environment = {
  production: true,
  buildId: '2510176222117371',
  configFile: 'config.json',
};
